export default __webpack_public_path__ + "media/zurb/img/b2b_ecommerce/le_usability-2b9ae543851fd254a40098a03ad8576d.png";